import {
  pointInCircle,
  pointInPolygon,
  Vector as V,
  Circle as C,
  Box as B,
  Circle,
} from "sat";

import { Stem, StemGraphicPositionObject } from "@examspark/types";

import { getNewScore } from ".";

export const scoreGraphicPositionObject = (
  expected: StemGraphicPositionObject,
  actual: Stem.Response,
) => {
  let correct: boolean = true;
  const score = getNewScore();
  const { content, scoring, config } = expected;

  if (!actual?.coords) {
    return score;
  }

  // get keys
  const keys: Array<string> = [];
  for (const k in scoring?.spots) {
    if (scoring?.spots[k]) {
      const element = scoring.spots[k];
      if (element.isKey) {
        keys.push(k);
      }
    }
  }

  content.spots?.forEach((spot: Stem.Spot) => {
    let collision: boolean = false;

    switch (spot.shape) {
      case "rect":
        collision = pointInPolygon(
          new V(actual.coords.x, actual.coords.y),
          new B(
            new V(spot.coords.x, spot.coords.y),
            spot.coords.w,
            spot.coords.h,
          ).toPolygon(),
        );
        break;
      case "circle":
        collision = pointInCircle(
          new V(actual.coords.x, actual.coords.y),
          new Circle(new V(spot.coords.x, spot.coords.y), spot.coords.r),
        );
        break;
    }

    if (keys.includes(spot.id) && !collision) {
      correct = false;
    }
  });

  score.max = 1;
  if (correct) {
    score.actual = 1;
  }

  return score;
};
